import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          // component: resolve => require(['@/view/HomePage'], resolve),
          component: resolve => require(['@/view/KepuResourcePage'], resolve),
          meta: {
            title: '科普资源'
          }
        }, {
          path: '/prodDetail',
          name: 'prodDetail',
          component: resolve => require(['@/view/ProdDetail'], resolve),
          meta: {
            title: '列表详情'
          }
        }, {
          path: '/technologyintroduction',
          name: 'technologyintroduction',
          component: resolve => require(['@/view/Technologyintroduction'], resolve),
          meta: {
            title: '成果列表'
          }
        }, 

                {
          path: '/scienceGraph', // 定义一个访问路径
          name: 'ScienceGraph',
          component: resolve => require(['@/view/sciencePopMMKG/index'], resolve),
          meta: {
            title: '知识图谱'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js